import type { BytemdSafeMdxViewerPlugin } from '@tarslib/bytemd-processor';

export default function pluginImageAddLoading(): BytemdSafeMdxViewerPlugin {
  return {
    viewerEffect({ markdownBody }) {
      (async () => {
        const images = markdownBody.querySelectorAll('img');
        images?.forEach((img) => {
          // eslint-disable-next-line no-param-reassign
          img.loading = 'lazy';
        });
      })();
    },
  };
}
